/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Debt_Fill_TotalInputs */

const vi_lot_debt_fill_total = /** @type {(inputs: Lot_Debt_Fill_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lô nhập: ${i?.qty} ${i?.unit}`)
};

/**

* @param {Lot_Debt_Fill_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_total = /** @type {((inputs: Lot_Debt_Fill_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_total(inputs)
});